import React from 'react'
import { Link } from 'react-router-dom'
export default function DashboardHome() {
  return (
    <div>
      <h2>BagSpa Dashboard</h2>
      <p className="text-muted">Quick links for sanity-check:</p>
      <ul>
        <li><Link to="/app/sales/bagspa/customers">Customers</Link></li>
        <li><Link to="/app/sales/bagspa/products">Products</Link></li>
        <li><Link to="/app/sales/bagspa/vouchers">Vouchers</Link></li>
        <li><Link to="/app/sales/bagspa/orders">Orders</Link></li>
        <li><Link to="/app/sales/bagspa/documents/tanda-masuk">Tanda Masuk</Link></li>
        <li><Link to="/app/sales/bagspa/payments">Payments</Link></li>
        <li><Link to="/app/sales/bagspa/shipments">Shipments</Link></li>
        <li><Link to="/app/sales/bagspa/audit-log/qc">Audit Log QC</Link></li>
        <li><Link to="/app/sales/bagspa/documents/surat-jalan">Surat Jalan</Link></li>
        <li><Link to="/app/sales/bagspa/documents/invoices">Invoices</Link></li>
        <li><Link to="/app/sales/bagspa/taxonomy">Taxonomy</Link></li>
      </ul>
      <p className="small text-muted">If a page renders, routing is good. Wire to real APIs next.</p>
    </div>
  )
}
